import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  checklistTemplateKeys,
  checklistTemplateEditorMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import { IChecklistTemplateVersion } from '@core/entities/checklist/ChecklistTemplateVersion'

export const useUpdateGlobalChecklistTemplateVersionWarning = (
  options?: UseMutationOptions<
    IChecklistTemplateVersion,
    RequestErrorType,
    RequestTypes['updateGlobalChecklistTemplateVersionWarning']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...checklistTemplateEditorMutationKeys.updateGlobalChecklistTemplateVersionWarning,
    ...options,
    onSuccess: (_, variables) => {
      const queryKey = checklistTemplateKeys.getVersion({
        templateId: variables.templateId,
        templateVersionId: variables.versionId,
      }).queryKey

      queryClient.invalidateQueries({ queryKey })
    },
  })
}
